import { encryptField, decryptField, type EncryptedPayload } from './crypto';

const STRIPE_KEY_PASSPHRASE = 'xmanage-stripe-key-envelope';

export async function encryptStripeKey(_businessId: string, stripeKey: string): Promise<string> {
  try {
    const payload = await encryptField(stripeKey, STRIPE_KEY_PASSPHRASE);
    return JSON.stringify(payload);
  } catch (error) {
    console.error('Error encrypting stripe key:', error);
    throw error;
  }
}

export async function decryptStripeKey(encryptedKey: string): Promise<string | null> {
  try {
    if (!encryptedKey) return null;

    try {
      const payload: EncryptedPayload = JSON.parse(encryptedKey);
      if (payload.ct && payload.iv && payload.salt) {
        const decrypted = await decryptField(payload, STRIPE_KEY_PASSPHRASE);
        if (decrypted.startsWith('sk_') || decrypted.startsWith('rk_')) return decrypted;
        return decrypted;
      }
    } catch {
      // fall through to legacy decode
    }

    const decoded = atob(encryptedKey);
    if (!decoded.startsWith('sk_')) return null;
    return decoded;
  } catch (error) {
    console.error('Error decrypting stripe key:', error);
    return null;
  }
}

export async function deleteStripeKey(_encryptedKey: string): Promise<void> {
}

const WISE_KEY_PASSPHRASE = 'xmanage-wise-key-envelope';

export async function encryptWiseKey(wiseKey: string): Promise<string> {
  const payload = await encryptField(wiseKey, WISE_KEY_PASSPHRASE);
  return JSON.stringify(payload);
}

export async function decryptWiseKey(encryptedKey: string | null): Promise<string | null> {
  try {
    if (!encryptedKey) return null;
    const payload: EncryptedPayload = JSON.parse(encryptedKey);
    if (payload.ct && payload.iv && payload.salt) {
      return await decryptField(payload, WISE_KEY_PASSPHRASE);
    }
    return null;
  } catch {
    return null;
  }
}

const MERCURY_KEY_PASSPHRASE = 'xmanage-mercury-key-envelope';

export async function encryptMercuryKey(mercuryKey: string): Promise<string> {
  const payload = await encryptField(mercuryKey, MERCURY_KEY_PASSPHRASE);
  return JSON.stringify(payload);
}

export async function decryptMercuryKey(encryptedKey: string | null): Promise<string | null> {
  try {
    if (!encryptedKey) return null;
    const payload: EncryptedPayload = JSON.parse(encryptedKey);
    if (payload.ct && payload.iv && payload.salt) {
      return await decryptField(payload, MERCURY_KEY_PASSPHRASE);
    }
    return null;
  } catch {
    return null;
  }
}
